import React from 'react';
import { ToastContainer, toast, Slide, Zoom, Flip, Bounce } from 'react-toastify';

export const transitionOptions = {
    Slide,
    Zoom,
    Flip,
    Bounce,
};

const SnackBar = () => (
    <ToastContainer hideProgressBar icon={false} position='top-right' theme='colored' draggable />
);
// const SnackBar = () => <frameElement/>
const getHeaderHeight = () => {
    const headerSelector = document.querySelector('header');
    if (!headerSelector) {
        console.error('Header not found. Setting the height to an arbitrary value of 126px.');
        return 126;
    }
    return headerSelector.offsetHeight + headerSelector.offsetTop;
};

export const infoToast = (message, configs) => {
    const {
        statusIcon = false,
        closeButton = false,
        autoClose = 5000,
        position,
        hideProgressBar = true,
        closeOnClick = false,
        pauseOnHover = true,
        pauseOnFocusLoss = true,
        transition = Bounce,
        toastId,
        className,
        toastClosed,
    } = configs || {};
    const ReturnToastId = toast.info(message, {
        className: `${statusIcon ? 'statusIcon body2 h-emphasis' : 'noStatusIcon body2 h-emphasis'}${className ? ` ${className}` : ''}`,
        autoClose,
        closeButton,
        position,
        hideProgressBar,
        closeOnClick,
        pauseOnHover,
        pauseOnFocusLoss,
        transition,
        toastId,
        onClose: toastClosed,
        style: {
            top: getHeaderHeight(),
        },
    });
    return ReturnToastId;
};
export const successToast = (message, configs) => {
    const {
        statusIcon = true,
        closeButton = false,
        autoClose = 5000,
        position, // Standard positions are 'top-right', 'top-center', 'top-left', 'bottom-right', 'bottom-center', 'bottom-left', but you can also provide custom positions in the format of { top: '10px', left: '10px' }
        hideProgressBar = true,
        closeOnClick = false,
        pauseOnHover = true,
        pauseOnFocusLoss = true,
        transition = Bounce,
        toastId,
        className,
        toastClosed,
    } = configs || {};
    const ReturnToastId = toast.success(message, {
        className: `${statusIcon ? 'statusIcon body2 h-emphasis' : 'noStatusIcon body2 h-emphasis'}${className ? ` ${className}` : ''}`,
        autoClose,
        closeButton,
        position,
        hideProgressBar,
        closeOnClick,
        pauseOnHover,
        pauseOnFocusLoss,
        transition,
        toastId,
        onClose: toastClosed,
        style: {
            top: getHeaderHeight(),
        },
    });
    return ReturnToastId;
};

export const warningToast = (message, configs) => {
    const {
        statusIcon = false,
        closeButton = true,
        autoClose = false,
        position,
        hideProgressBar = true,
        closeOnClick = false,
        pauseOnHover = true,
        pauseOnFocusLoss = true,
        transition = Bounce,
        toastClosed,
    } = configs || {};
    const toastId = toast.warning(message, {
        className: statusIcon ? 'statusIcon body2 h-emphasis' : 'noStatusIcon body2 h-emphasis',
        autoClose,
        closeButton,
        position,
        hideProgressBar,
        closeOnClick,
        pauseOnHover,
        pauseOnFocusLoss,
        transition,
        onClose: toastClosed,
        style: {
            top: getHeaderHeight(),
        },
    });
    return toastId;
};

export const errorToast = (message, configs) => {
    const {
        statusIcon = true,
        closeButton = true,
        autoClose = false,
        position,
        hideProgressBar = true,
        closeOnClick = false,
        pauseOnHover = true,
        pauseOnFocusLoss = true,
        transition = Bounce,
    } = configs || {};
    const toastId = toast.error(message, {
        className: statusIcon ? 'statusIcon body2 h-emphasis' : 'noStatusIcon body2 h-emphasis',
        autoClose,
        closeButton,
        position,
        hideProgressBar,
        closeOnClick,
        pauseOnHover,
        pauseOnFocusLoss,
        transition,
        style: {
            top: getHeaderHeight(),
        },
    });
    return toastId;
};

export const updateToast = (toastId, configs) => {
    const {
        closeButton = true,
        autoClose = false,
        position,
        content,
        type, // type can be 'info', 'success', 'warning', 'error', or 'default'
        hideProgressBar = true,
        closeOnClick = false,
        pauseOnHover = true,
        pauseOnFocusLoss = true,
        transition = Bounce,
        className,
    } = configs || {};
    toast.update(toastId, {
        render: content,
        closeButton,
        autoClose,
        position,
        hideProgressBar,
        closeOnClick,
        pauseOnHover,
        pauseOnFocusLoss,
        transition,
        ...(type !== undefined && { type }),
        ...(className !== undefined && { className }),
        toastId,
        style: {
            top: getHeaderHeight(),
        },
    });
};

export const isSnackBarActive = (id) => toast.isActive(id);

export default SnackBar;
